import { render, staticRenderFns } from "./nfItem.vue?vue&type=template&id=605e7b29&scoped=true&"
import script from "./nfItem.vue?vue&type=script&lang=js&"
export * from "./nfItem.vue?vue&type=script&lang=js&"
import style0 from "./nfItem.vue?vue&type=style&index=0&id=605e7b29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e7b29",
  null
  
)

export default component.exports